import React from 'react';
import DeleteServiceDialog from '../../Services/components/ServiceDeleteDialog';
import { DeleteVendorOffer } from '../../../../../../Services';

const DeleteOfferDialog = ({ onClose, activeItem, open, reload }) => {
  const deleteOfferHandler = async () => {
    await DeleteVendorOffer(activeItem?.vendorOfferId);
    reload();
  };

  return (
    <DeleteServiceDialog
      open={open}
      onClose={onClose}
      onSave={deleteOfferHandler}
      title={'delete_offer'}
      itemName={activeItem.offerName}
    />
  );
};
export default DeleteOfferDialog;
